import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopArticleDigitalAssetApi from '../generated/api/ShopArticleDigitalAsset';

export default (service: Servicelayer) => ({
  ...ShopArticleDigitalAssetApi(service),

  // Add custom calls here

});
